/**
 * XP System Configuration
 * Defines experience points, levels, and progression rules
 */

const XP_SYSTEM = {
    // XP Rewards
    rewards: {
        stepCorrect: 10,        // Por acertar un paso
        problemComplete: 50,    // Por completar un problema
        firstTry: 20,          // Bonus por acertar a la primera
        perfectProblem: 30,    // Bonus por completar sin fallos
        streak3: 25,           // Bonus por racha de 3
        streak5: 50,           // Bonus por racha de 5
        dailyLogin: 10         // Por jugar cada día
    },

    // Level thresholds (XP needed to reach each level)
    levels: [
        { level: 1, xpRequired: 0, title: 'Aprendiz Detective' },
        { level: 2, xpRequired: 100, title: 'Detective Junior' },
        { level: 3, xpRequired: 250, title: 'Detective' },
        { level: 4, xpRequired: 500, title: 'Detective Experto' },
        { level: 5, xpRequired: 1000, title: 'Super Detective' },
        { level: 6, xpRequired: 1500, title: 'Detective Maestro' },
        { level: 7, xpRequired: 2000, title: 'Detective Legendario' },
        { level: 8, xpRequired: 3000, title: 'Gran Maestro' },
        { level: 9, xpRequired: 4000, title: 'Detective Supremo' },
        { level: 10, xpRequired: 5000, title: 'Sherlock Holmes Jr.' }
    ],

    // Get level info for a given XP amount
    getLevelInfo(totalXP) {
        for (let i = this.levels.length - 1; i >= 0; i--) {
            if (totalXP >= this.levels[i].xpRequired) {
                const currentLevel = this.levels[i];
                const nextLevel = this.levels[i + 1] || null;

                return {
                    level: currentLevel.level,
                    title: currentLevel.title,
                    currentXP: totalXP,
                    levelXP: currentLevel.xpRequired,
                    nextLevelXP: nextLevel ? nextLevel.xpRequired : null,
                    xpInLevel: totalXP - currentLevel.xpRequired,
                    xpToNextLevel: nextLevel ? nextLevel.xpRequired - totalXP : 0,
                    isMaxLevel: !nextLevel
                };
            }
        }

        return this.levels[0];
    },

    // Calculate XP progress percentage for current level
    getProgressPercentage(totalXP) {
        const info = this.getLevelInfo(totalXP);
        if (info.isMaxLevel) return 100;

        const xpInLevel = info.xpInLevel;
        const xpForLevel = info.nextLevelXP - info.levelXP;

        return Math.min(100, Math.floor((xpInLevel / xpForLevel) * 100));
    }
};

// Expose globally
window.XP_SYSTEM = XP_SYSTEM;

console.log('⚙️ XP System configured');
